import React from 'react'

export const Warn = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.4346 8.06903C6.446 4.50991 7.45169 2.73034 8.83176 2.27226C9.59092 2.02025 10.4088 2.02025 11.1679 2.27226C12.548 2.73034 13.5537 4.50991 15.5651 8.06903C17.5765 11.6281 18.5822 13.4077 18.2805 14.8577C18.1145 15.6554 17.7056 16.3789 17.1123 16.9247C16.034 17.9166 14.0227 17.9166 9.99984 17.9166C5.97705 17.9166 3.96565 17.9166 2.88731 16.9247C2.29407 16.3789 1.88517 15.6554 1.71919 14.8577C1.4175 13.4077 2.4232 11.6281 4.4346 8.06903Z" stroke="#141B34" stroke-width="1.5"/>
<path d="M9.99316 13.3334H9.99991" stroke="#141B34" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 10.8334V7.5" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  )
}
